import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';

import { queryKeys } from '../../../api/query-keys';
import { useAuth } from '../../../auth/AuthProvider';
import { permissions } from '../../../auth/permissions';
import { createFacility, listFacilities } from './facilities.api';

export function useFacilities() {
  const auth = useAuth();
  return useQuery({
    queryKey: queryKeys.facilities(auth.activeCustomerId),
    queryFn: () => listFacilities(auth.activeCustomerId!),
    enabled: Boolean(auth.activeCustomerId && auth.can(permissions.facilitiesRead)),
  });
}

export function useCreateFacility() {
  const auth = useAuth();
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (input: { facilityName: string; location: string | null }) => createFacility(auth.activeCustomerId!, input),
    onSuccess: async () => {
      await queryClient.invalidateQueries({ queryKey: queryKeys.facilities(auth.activeCustomerId) });
    },
  });
}
